export default {
  '0' : 'success',
  '10001' : '用戶不存在',
  '10002' : '用戶密碼錯誤',
  '10003' : 'Token 無效',
  '10004' : '用戶登出失敗',
  '10005' : '登錄名不能為空',
  '10006' : '登錄密碼不能為空',
  '10007' : '保存報價單發生錯誤',
  '10008' : '保存報價單發生異常',
  '10009' : '創建編號出錯，請重試',
  '10010' : '該保單可能不存在',
  '10011' : '修改報價單發生錯誤',
  '10012' : '修改報價單發生異常',
  '10013' : '生成文件發生異常',
  '10014' : '文件可能不存在',
  '10015' : '查詢不到記錄',
  '10016' : '導出文件發生異常',
  '10017' : '驗證失敗',

  '10018' : 'Office 不能為空',
  '10019' : 'Account Number 不能為空',
  '10020' : 'Business Type 不能為空',
  '10021' : 'Vehicle Usage 不能為空',
  '10022' : 'Body Type 不能為空',
  '10023' : 'Year of Manufacturing 不能為空',
  '10024' : 'Cubic Capacity 不能為空',
  '10025' : 'Driving License Type 不能為空',
  '10026' : 'Date of Birth 不能為空',
  '10027' : 'Occupation 不能為空',
  '10028' : 'NCD 不能為空',
  '10029' : 'Basic Premium 不能為空',
  '10030' : 'Loading 不能為空',
  '10031' : 'Client Discount 不能為空',
  '10032' : 'MIB 不能為空',
  '10033' : 'IA Levy 不能為空',
  '10034' : 'Effective Date & Time 不能為空',
  '10035' : 'Proposer Name 不能為空',
  '10036' : 'Adjusted Premium 不能大於 Total Premium',
  '10037' : 'Make 不能為空',
  '10038' : 'Cubic Capacity 為1~4位數字',
  '10039' : 'Year of Manufacturing 格式yyyy',
  '10040' : 'Date of Birth 格式DD-MM-YYYY',
  '10041' : 'Adjusted Premium 不能為空',
  '10042' : '只能輸入數字',
  '10043' : 'Insurer 不能為空',
  '10044' : 'Effective Date & Time 格式DD-MM-YYYY HH:MM',
  '10045' : 'Model 不能為空',
  '10046' : 'Engine Number 不能為空',
  '10047' : 'Chassis Number 不能為空',
  '10048' : 'Seating Capacity 不能為空',
  '10049' : '按鈕類型不能為空',
  '10050' : 'HKID 不能為空',
  '10051' : 'Mobile Number 不能為空',
  '10052' : 'Registration Number 不能為空',
  '10053' : 'MVC 編碼超出範圍',
  '10054' : 'EVC 編碼超出範圍',
  '10055' : 'Policy 編碼超出範圍',
  '10056' : 'Occupation 不得超過60個字符',
  '10057' : 'Proposer Name 不得超過120個字符',
  '10058' : 'HKID 不得超過30個字符',
  '10059' : 'Mobile Number 不得超過8個字符',
  '10060' : 'Address 不得超過30個字符',
  '10061' : 'Registration Number 不得超過16個字符',
  '10062' : 'Engine Number 不得超過24個字符',
  '10063' : 'Chassis Number 不得超過20個字符',
  '10064' : 'Make 自定義車廠不能為空',
  '10065' : '請先保存該保單',
  '10066' : '保存保單狀態出錯，請重試',
  '10067' : '無法處理該保單狀態',
  '10068' : 'Display Body Type 不能為空',
  '10069' : 'Proposer Type 必須選擇',
  '10070' : 'Company BR Number 不能為空',
  '10071' : 'Company BR Number 不得超過125個字符',
  '10072' : 'Start Date 不能為空',
  '10073' : 'End Date 不能為空',
  '10074' : '日期格式不正確',
  '10075' : '保單已被鎖定，您沒有權限修改此保單',
  '10076' : 'failure! 更新數據失敗！',
  '10077' : '您沒有足夠的權限進行此操作！',
  '10078' : 'Endorsement Can\'t Issue Policy !',
}